import { useTranslation } from "react-i18next";
import { formatPrice } from "../../../../../../Utils/ServiceUtils/ServiceUtils";

const ServiceDeviceDetails = ({ device }) => {
  const { t } = useTranslation();
  if (!device?.uuid) return null;

  return (
    <div className="device-details">
      <div className="label">{t("global:service.manufacturerAndModel")}</div>
      <div className="value">
        {device?.printerModel?.manufacturer?.entryName}{" "}
        {device?.printerModel?.modelName}
      </div>

      <div className="label">{t("global:service.deviceType")}</div>
      <div className="value">{device?.printerModel?.deviceType.entryName}</div>

      <div className="label">{t("global:service.deviceOwner")}</div>
      <div className="value">{device?.deviceOwner?.entryName || "-"}</div>

      <div className="label highlight">
        {t("global:service.servicePriority")}
      </div>
      <div className="value">{device?.servicePriority?.entryName || "-"}</div>

      <div className="label">{t("global:service.servicePrice")}</div>
      <div className="value">
        {device?.printerModel?.servicePrice?.name || "-"}
      </div>

      {[
        ["Przegląd okresowy", "surveyPrice"],
        ["Naprawa", "repairPrice"],
        ["Instalacja", "installationPrice"],
        ["Diagnostyka", "diagnosticsPrice"],
        ["Usługa IT", "itServicePrice"],
        ["Usługa zdalna", "remotePrice"],
      ].map(([label, key]) => (
        <>
          <div className="label">{label}</div>
          <div className="value price">
            {formatPrice(device?.printerModel?.servicePrice?.[key])} PLN
          </div>
        </>
      ))}

      <div className="label">{t("global:service.client")}</div>
      <div className="value">{device?.client?.name}</div>
    </div>
  );
};

export default ServiceDeviceDetails;
